// @flow
import React, { useContext, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Add from '@material-ui/icons/AddBox';
import { articleEdit } from '../articles/edit.util';
import { ApiContext } from './context';
import ArticleSelector from '../articles/ArticleSelector';

import './home.css';

export const Placeholder = props => {
	const [articles, setArticles] = useState([]);
	const handleAddClick = () => {
		props.onAddClick(articles[0].id, props.order);
	};
	const hint = props.hint || `Добавить материал на ${props.order} позицию`;
	return (
		<div className="placeholder">
			<div className="input-wrapper">
				<ArticleSelector
					limit={1}
					section={props.section}
					hint="Введите название материала"
					viewer={props.viewer}
					value={articles}
					onChange={setArticles}
					disabled={false}
				/>
				<IconButton disabled={articles.length === 0} onClick={handleAddClick}>
					<Add />
				</IconButton>
			</div>
			<div className="hint">{hint}</div>
		</div>
	);
};

export const PlaceholderContainer = props => {
	const { refetch } = useContext(ApiContext);
	const handleAddClick = (id: string, mainPageOrder = 0) => {
		articleEdit(
			id,
			input => (input.mainPageOrder = mainPageOrder),
			() => refetch(),
		);
	};
	return <Placeholder {...props} onAddClick={handleAddClick} />;
};



// WEBPACK FOOTER //
// src/components/home/placeholder.js